import { api } from './client';

export interface BankOption {
  key: string;
  label: string;
  logo: string | null;
  installments: { enabled: boolean; max: number; rates?: number[] };
}

export interface PaymentSummary {
  orderId: string;
  bankKey: string | null;
  amount: string;
  installment: number;
  status: 'pending' | 'approved' | 'failed';
  authCode: string | null;
  createdAt: string;
}

export interface PaymentDetail {
  payment: {
    orderId: string;
    amount: string;
    currency: string;
    installment: number;
    bankKey: string | null;
    status: 'pending' | 'approved' | 'failed';
    reviewStatus: 'awaiting' | 'approved' | 'rejected';
    authCode: string | null;
    createdAt: string;
    errorMessage?: string | null;
  };
  customer: {
    fullName: string | null;
    companyName: string | null;
    email: string;
    phone: string | null;
    taxNumber: string | null;
    address: string | null;
  } | null;
}

export interface CardInput {
  number: string;
  expiryMonth: string;
  expiryYear: string;
  cvv: string;
  holder?: string;
}

export interface InitiateInput {
  bankKey: string;
  amount: number;
  installment: number;
  card: CardInput;
  termsAccepted: boolean;
}

export interface InitiateResult {
  orderId: string;
  relayHtml?: string;
  gatewayUrl?: string;
  fields?: Record<string, string>;
}

export interface BayiSummary {
  totalPaid: number;
  approvedCount: number;
  failedCount: number;
  pendingCount: number;
  successRate: number;
  paidDeltaPct: number | null;
  weekly: Array<{ label: string; value: number }>;
  bankDistribution: Array<{ key: string; label: string; count: number; pct: number }>;
  recent: Array<{
    order_id: string;
    amount: string;
    bank_key: string | null;
    status: string;
    review_status: string;
    created_at: string;
  }>;
}

export const paymentsApi = {
  banks: () => api.get<{ banks: BankOption[] }>('/payments/banks').then((r) => r.banks),
  summary: () => api.get<BayiSummary>('/payments/summary'),
  mine: () => api.get<{ payments: PaymentSummary[] }>('/payments/mine').then((r) => r.payments),
  detail: (orderId: string) => api.get<PaymentDetail>(`/payments/${encodeURIComponent(orderId)}`),
  initiate: (input: InitiateInput) => api.post<InitiateResult>('/payments/initiate', input),
};
